<template>
  <div>
    <div class="frameBg" v-show="showModal" style="z-index:2000"></div>
    <div class="framework-box" v-if="isVefCode">
      <div class="framework" >
      <div class="boxTopTitle">
        <div class="l "><b class="font14">完成拼图验证</b></div>
        <div class="r"><a class="marR10 colGray9" @click="clkNext">
            <i class="fa fa-refresh" style="margin-top:-3px;"></i>换一张</a><a class="colGray9" @click="clkCloseRef">X</a></div>
      </div>
      <div class="boxImg">
        <div class="cutImgSet" :style="{top:CutImgY+'px'}" ref="puzzleLost" @mousedown="startMove" @touchstart="phoneTouchStart"><img :src="CutImg" style="cursor:pointer;" /></div>
        <img :src="BGImg" />
      </div>
      <div class="joeBlock">
        <!-- :style="{width:bgGreenW+'px'}" -->
        <div class="BgSet" :class="bgColSet?'bgColRed':''" ref="puzzleShadow"></div>
        <div class="joeBtn" id="joeID" ref="sliderBtn" @mousedown="startMove" @touchstart="phoneTouchStart">
          <i class="fa lnr-chevron-left setIcon"></i>
        </div>
        <p class="joeText" style="user-select:none;">向右滑动完成拼图验证</p>
      </div>
    </div>
    </div>
    

  </div>

</template>
<script>
import { post, fetch, Del, put } from "../../../ask/axios";
import bus from '../../../ask/eventBus'
export default {
  props: {
    inputPhone: '',
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },

      BGImg: '',
      CutImg: '',
      CutImgY: '',
      MarkCode: '',//验证拼图是否成功用

      bgGreenW: null,
      moveStart: '',
      moveStartY: '',
      bgColSet: false, //拼图是否验证成功

      randomX: null,
      randomY: null,

      phoneX: null,// 手机滑动X轴

      isVefCode: false,
      showModal: false

    }
  },
  created() {
    // this.GetSlideBlockApi();
  },
  mounted() {

  },
  watch: {
    showModal(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    }
  },
  computed: {

  },
  methods: {
    //获取图片接口
    GetSlideBlockApi() {
      let that = this;
      let phoneNum = this.inputPhone.trim()
      that.api.param = {
        Mobile: phoneNum,
      }
      // that.api.url = this.$api02 + "/api/EbayCustomer/SlideBlock/GetSlideBlock";
      that.api.url = this.$api04 + "Basics/api/SlideBlock/GetSlideBlock";
      fetch(that.api.url, that.api.param).then(function (res) {

        that.BGImg = 'data:image/png;base64,' + res.Results.BGImg
        that.CutImg = 'data:image/png;base64,' + res.Results.CutImg
        that.CutImgY = res.Results.Y
        that.MarkCode = res.Results.MarkCode
        // console.log('that.CutImgY ' + that.CutImgY);
      })
    },

    /* 按住滑块后初始化移动监听，记录初始位置 */
    startMove(e) {
      e.preventDefault()  //禁止图片img拖动的解决方法

      // 
      e = e || window.event;
      this.$refs.sliderBtn.style.backgroundPosition = "0 -216px";
      this.moveStart = e.pageX || e.targetTouches[0].pageX;
      //this.moveStartY = e.pageY || e.targetTouches[0].pageY;
      // const rect=e.target.getBoundingClientRect()//获取点击的dom的位置
      //this.moveStart= rect 
      this.addMouseMoveListener();
    },

    /* 全局绑定滑块移动与滑动结束，移动过程中鼠标可在页面任何位置 */
    addMouseMoveListener() {
      let self = this;
      document.addEventListener("mousemove", self.moving);
      document.addEventListener("mouseup", self.moveEnd);
    },

    /* 滑块移动 */
    moving(e) {
      e.preventDefault() //禁止图片img拖动的解决方法
      let self = this;
      e = e || window.event;
      let moveX = (e.pageX || e.targetTouches[0].pageX);

      let d = moveX - self.moveStart;

      let w = self.dataWidth;
      let PL_Size = this.puzzleSize;
      let padding = this.padding;

      if (self.moveStart === "") {
        return "";
      }
      if (d < 0 || d > w - padding - PL_Size) {
        return "";
      }

      if (d <= 260) {
        self.$refs.sliderBtn.style.left = d + "px";
        self.$refs.sliderBtn.style.transition = "inherit";
        self.$refs.puzzleLost.style.left = d + "px";
        self.$refs.puzzleLost.style.transition = "inherit";
        self.$refs.puzzleShadow.style.width = d + 25 + "px";
        self.$refs.puzzleShadow.style.transition = "inherit";

        self.bgGreenW = d //绿色滚条
        self.randomX = d
        //console.log('self.randomX ' +  self.randomX);
      }

    },
    /* 移动结束，验证并回调 */
    moveEnd(e) {
      let self = this;

      e = e || window.event;
      let moveEnd_X = (e.pageX || e.changedTouches[0].pageX) - self.moveStart;
      //let moveEnd_Y = (e.pageY || e.changedTouches[0].pageY) - self.moveStartY;

      //   let Y=Math.abs(moveEnd_Y)
      //  if(Y >= 0){
      //    self.randomY=Y
      //  }


      // console.log('randomX  '+   this.randomX);
      // console.log('moveEnd_X  '+   moveEnd_X);
      // console.log('初始Y  '+   moveEnd_Y);
      // console.log('验证图片Y  '+   self.randomY);

      if (moveEnd_X > 0) {
        self.CheckSlideBlockApi();//验证拼图是否成功
      }
      self.moveStart = "";

      document.removeEventListener("mousemove", self.moving);
      document.removeEventListener("mouseup", self.moveEnd);
    },

    //手机滑动事件
    phoneTouchStart(e) {//手指接触屏幕
      let self = this;
      document.body.parentNode.style.overflowY = "hidden";
      // e = e || window.event;
      // this.phoneX =e.pageX || e.touches[0].pageX;

      e = e || window.event;
      this.$refs.sliderBtn.style.backgroundPosition = "0 -216px";
      this.moveStart = e.pageX || e.touches[0].pageX;

      //document.addEventListener("touchmove", self.touchmoving); 
      // document.addEventListener("touchend", self.touchmoveEnd);

      document.addEventListener("touchmove", self.touchmoving, e.preventDefault(), false,);//禁止页面滑动
      document.addEventListener("touchend", self.touchmoveEnd);


    },


    touchmoving(e) {//手指滑块移动
      //e.preventDefault() //禁止图片img拖动的解决方法
      // e.preventDefault();
      // e.stopPropagation();
      let self = this;
      e = e || window.event;
      let moveX = (e.pageX || e.targetTouches[0].pageX);


      //console.log('moveX ' +  moveX);

      let d = moveX - self.moveStart;

      let w = self.dataWidth;
      let PL_Size = this.puzzleSize;
      let padding = this.padding;

      if (self.moveStart === "") {
        return "";
      }
      if (d < 0 || d > w - padding - PL_Size) {
        return "";
      }

      if (d <= 260) {
        self.$refs.sliderBtn.style.left = d + "px";
        self.$refs.sliderBtn.style.transition = "inherit";
        self.$refs.puzzleLost.style.left = d + "px";
        self.$refs.puzzleLost.style.transition = "inherit";
        self.$refs.puzzleShadow.style.width = d + 25 + "px";
        self.$refs.puzzleShadow.style.transition = "inherit";

        self.bgGreenW = d //绿色滚条
        self.randomX = Math.round(d)
        //console.log('self.randomX ' +  self.randomX);
      }
    },
    //手指离开屏幕
    touchmoveEnd(e) { //
      let self = this;

      e = e || window.event;
      let moveEnd_X = (e.pageX || e.changedTouches[0].pageX) - self.moveStart;
      if (moveEnd_X > 0) {
        self.CheckSlideBlockApi();//验证拼图是否成功
      }
      self.moveStart = "";

      //document.removeEventListener("touchmove", self.touchmoving);
      document.removeEventListener("touchmove", self.touchmoving, e.preventDefault(), false);
      document.removeEventListener("touchend", self.touchmoveEnd);
    },


    //初始化
    setOut() {
      let self = this;
      self.$refs.sliderBtn.style.left = 0;
      self.$refs.sliderBtn.style.transition = "left 0.5s";
      self.$refs.puzzleLost.style.left = 0;
      self.$refs.puzzleLost.style.transition = "left 0.5s";
      self.$refs.puzzleShadow.style.width = 0;
      self.$refs.puzzleShadow.style.transition = "width 0.5s";
      setTimeout(() => {
        self.bgColSet = false;
      }, 500)
      //this.bgGreenW=0
    },

    //验证图片接口
    CheckSlideBlockApi() {
      let that = this;
      let Track = [{ X: that.randomX, Y: that.CutImgY, }]
      let phoneNum = this.inputPhone.trim()
      that.api.param = {
        Mobile: phoneNum,
        MarkCode: that.MarkCode,
        LstMouseTrack: Track
      }
      // that.api.url = this.$api02 + "/api/EbayCustomer/SlideBlock/CheckSlideBlock";
      that.api.url = this.$api04 + "Basics/api/SlideBlock/CheckSlideBlock";
      post(that.api.url, that.api.param).then(function (res) {


        //定制埋点--拼图验证是否成功
        sensors.track('click_to_verify', {
          is_success: res.Results,
          fail_reason: res.Message,
        });


        let infos = {}
        if (res.IsOK == true && res.Results == true) {
          that.isVefCode = false,
            that.showModal = false,
            infos = {
              Res: res.Results,
              MarkCode: that.MarkCode,
              LstMouseTrack: Track
            },
            that.bgColSet = false,
            that.$emit('VefCodeTrue', infos)
        } else {
          that.bgColSet = true,
            that.GetSlideBlockApi()
        }
        that.setOut();
      })
    },

    //换一张
    clkNext() {
      this.GetSlideBlockApi()
    },
    clkCloseRef() {
      this.showModal = false
      this.isVefCode = false
    },
    clkOpenRef() {
      this.showModal = true
      this.isVefCode = true
    },
  }
}
</script>
<style type="text/css" rel="stylesheet" scoped="scoped">
.framework-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;
    display: flex;
    align-items: center;
    justify-content: center;
}

.framework {
  width: 300px;
  height: 230px;
  background: #fff;
  /* margin: 20px auto; */
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  /* z-index: 2001; */
  /* position: absolute; */
  padding: 0 10px 10px;
  user-select: none;
  border-radius: 5px;
  /* top: 50%;
  left: 50%;
  margin-left: -110px;
  margin-top: -175px; */
}
.framework .boxTopTitle {
  height: 35px;
  width: 280px;
  padding: 0 10px;
  line-height: 35px;
}
.framework .boxImg {
  width: 300px;
  height: 150px;
  background: #fff;
  margin: 0px auto 10px;
  position: relative;
}
.framework .joeBlock {
  width: 300px;
  height: 35px;
  background: #e6fbff;
  border: 1px solid #c3e3e9;
  position: relative;
  border-radius: 30px;
  overflow: hidden;
}
.framework .joeBlock .joeBtn {
  position: absolute;
  left: 0px;
  top: 0px;
  cursor: pointer;
  color: #0c5ee4;
  background: #fff;
  width: 45px;
  height: 35px;
  border-radius: 30px;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.framework .joeBlock .joeBtn .setIcon {
  position: absolute;
  left: 12px;
  top: 6px;
  font-size: 24px;
}
.framework .joeBlock .joeText {
  text-align: center;
  font-size: 16px;
  line-height: 35px;
  color: #10b2fa;
}
.framework .joeBlock .BgSet {
  background: #10b2fa;
  display: block;
  height: 35px;
  position: absolute;
}
.bgColRed {
  background: #ff4165 !important;
}
.cutImgSet {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/Reception/reg/validationPT.vue